export function isLocal() {
  return process.env.NEXT_PUBLIC_IS_LOCAL === 'true'
}
